/**
 * SegmentBadge — E-90, Story 2.2
 * Displays partner segment as a colored badge.
 */

import { useTranslation } from '@kgc/i18n';
import { Badge } from '@kgc/ui';

interface SegmentBadgeProps {
  segment: string;
  compact?: boolean | undefined;
}

const SEGMENT_CONFIG: Record<string, { color: string; icon: string; key: string }> = {
  VIP: {
    color: 'bg-amber-100 text-amber-800 border-amber-300',
    icon: '⭐',
    key: 'partner.segment.vip',
  },
  ACTIVE: {
    color: 'bg-green-100 text-green-800 border-green-300',
    icon: '🟢',
    key: 'partner.segment.active',
  },
  AT_RISK: {
    color: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    icon: '🟡',
    key: 'partner.segment.atRisk',
  },
  INACTIVE: {
    color: 'bg-red-100 text-red-800 border-red-300',
    icon: '🔴',
    key: 'partner.segment.inactive',
  },
};

export function SegmentBadge({ segment, compact }: SegmentBadgeProps) {
  const { t } = useTranslation();
  const config = SEGMENT_CONFIG[segment];
  if (!config) return null;

  return (
    <Badge variant="outline" className={`${config.color} text-xs`}>
      {config.icon}
      {!compact && <span className="ml-1">{t(config.key)}</span>}
    </Badge>
  );
}
